export const CONCRETE_CLASS_CONFIG_TYPE = {
  CONCRETE_CLASSES: 'ConcreteClasses',
};
